function fixAddToCartButtons(){
  //console.log("fixAddToCartButtons:",Array.from(document.querySelectorAll(".boost-pfs-filter-product-bottom-inner")).map(el=> el.querySelector('a').href.split('').reverse().join("").substring(1,11) +"  "+ el.querySelector("form")?.dataset.href.split('').reverse().join("").substring(0,10)));
  setTimeout(() => {
        [...document.querySelectorAll(".boost-pfs-action-list-wrapper.boost-pfs-action-extend")].forEach(elem => {
            elem.className = elem.className.replace("boost-pfs-action-list-wrapper", "boost-pfs-action-list-wrappers").replace("boost-pfs-action-extend", "boost-pfs-action-extends");
            elem.style = "";
        });
  },1000);
}
function customItemGrid(data, html) {
    if (window.location.href.indexOf('robert') > 0)
        console.log("customItemGrid", data, html);
  
      //console.log("BOOST PFS BEFORE EDIT");
    setTimeout(() => {
        [...document.querySelectorAll(".boost-pfs-action-list-wrapper.boost-pfs-action-extend")].forEach(elem => {
            elem.className = elem.className.replace("boost-pfs-action-list-wrapper", "boost-pfs-action-list-wrappers").replace("boost-pfs-action-extend", "boost-pfs-action-extends");
            elem.style = "";
        });
      //console.log("BOOST PFS EDIT");

    }, 500);
    return html;
}
function _customItemList(data, html) {
    console.log("customItemList", data, html);
    return html;
}
setTimeout(() => {
    [...document.querySelectorAll(".boost-pfs-action-list-wrapper.boost-pfs-action-extend")].forEach(elem => {
        elem.className = elem.className.replace("boost-pfs-action-list-wrapper", "boost-pfs-action-list-wrappers").replace("boost-pfs-action-extend", "boost-pfs-action-extends");
        elem.style = "";
    });

}, 1500);

function toggleExpandedSticky() {
    var toggleElement = document.querySelector(".boost-pfs-filter-toolbar-top-mobile");
    if (toggleElement.classList.contains('expanded')) {
        toggleElement.classList.remove('expanded');
    } else {
        toggleElement.classList.add('expanded');
    }
}
function sortTags() {
    console.log("sortTags");
    function sortEventsByOrder(a, b) {
        const startA = parseInt($(a).data('count'));
        const startB = parseInt($(b).data('count'));
        return startB - startA;
    }

    $('.boost-pfs-tags-container').html($('.boost-pfs-tags-container .boost-pfs-tag').sort(sortEventsByOrder))
}
setTimeout(sortTags, 2000);

var cancelled = false;
var myTimeout = undefined;
var toggleElementOffset = 250;
setTimeout(() => {
    toggleElementOffset = window.pageYOffset + document.querySelector(".boost-pfs-filter-toolbar-top-mobile").getBoundingClientRect().top - 40;
    console.log("ELEMOFFSET:", toggleElementOffset);
}, 1000);
document.addEventListener('scroll', (e) => {
    if (myTimeout != undefined) {
        clearTimeout(myTimeout);
        myTimeout = undefined;
    }
    myTimeout = setTimeout(function () {
        var toggleElement = document.querySelector(".boost-pfs-filter-toolbar-top-mobile");
        if (toggleElement != undefined) {

            console.log("SCROLL", toggleElementOffset, window.scrollY);

            if (toggleElementOffset < window.scrollY) {
                if (!toggleElement.classList.contains("boost-pfs-filter-stick"))
                    toggleElement.classList.add("boost-pfs-filter-stick");
            } else {
                if (toggleElement.classList.contains("boost-pfs-filter-stick"))
                    toggleElement.classList.remove("boost-pfs-filter-stick");
            }
        }
    }, 100);
});

function addToCartClickCustomEvent(ev) {
    console.log("addToCartClickCustomEvent", ev, ev.target, "Index:", ev.target?.innerText.indexOf("SELECT OPTIONS"));
    if (ev.target?.innerText.indexOf("SELECT OPTIONS") >= 0) {
        ev.preventDefault();
        ev.stopPropagation();
        var url = ev.target.closest("form").dataset.href;
        //document.querySelector(".boost-pfs-modal-backdrop").remove();
        window.location.href = url;
        return;
    }
    setTimeout(() => {
        document.querySelector('.brator-header-top-bar-area-main .brator-info-right .brator-cart-link a').click();
        // axios({ method: "get", url: `/cart.js` }).then(response => {
        //     console.log("Cart total: ", response.data.total_price, response.data.item_count);
        //     if (response != undefined && response.data != undefined) {
        //         document.querySelector(".brator-cart-icon span").innerText = response.data.item_count;
        //         document.querySelector("#cart-icon-bubble b").innerText = Shopify.formatMoney(response.data.total_price);
        //     }
        // });
    }, 500);
}